const emailCollectionState = {
  title: "Stay tuned",
  description: "Sign up to get the latest news, updates and special offers",
  background: {
    type: "image",
    imageURL: "",
    color: "",
  },
  actionData: {
    signUpButtonText: "Sign up",
    actionType: "emailCollection",
    actionTemplate: "default",
  },
};

export default emailCollectionState;
